module.exports = __webpack_public_path__ + "src/components/Feedback/guarantee.svg?4dc7f7d7";


//////////////////
// WEBPACK FOOTER
// ./src/components/Feedback/guarantee.svg
// module id = 3089
// module chunks = 8